import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMeanIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Symbols",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		fillOpacity: .84,
		children: /* @__PURE__ */ _jsx("g", {
			id: "Icons-(Platform)/mean_24px",
			fill: "#000000",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.4837116,21 L13.9505857,21 L12.9013543,18.0875716 L12.1733163,15.7827722 L11.9806003,15.7827722 L10.5673499,18.0875716 L8.49030015,21 L5,21 L10.4816984,13.4360673 L7.71943631,6.375 L11.2739751,6.375 L12.1090776,8.70075215 L12.8157028,11.047457 L12.9870059,11.047457 L14.4859078,8.70075215 L16.1561127,6.375 L19.625,6.375 L14.5501464,13.4779728 L17.4837116,21 Z M7.25,3 L19.625,3 L19.625,5.25 L7.25,5.25 Z",
				id: "icon"
			})
		})
	})
});
export default SvgMeanIcon;
